import { pickBy } from '@/utils'
import NavItem from "./nav-item.vue";
import { cloneDeep } from 'lodash'
import { transformInTem } from "../../utils"

export default {
  name: 'crmMemberActivity',
  setting: [
    {
      label: '参与状态',
      key: 'joinStatus',
      component: 'radiobutton',
      options: [
        { name: '未参与', label: 'canJoin' },
        { name: '已参与', label: 'cannotJoin' }
      ],
      value: 'canJoin'
    },
    {
      label: '自定义模块',
      key: 'data',
      component: function (h, { key }) {
        return (
          <NavItem
            v-model={this.value[key]}
            type={this.value.joinStatus}
            uuid={this.value.uuid}
            size='small'
          />
        )
      },
      value: {
        canJoin: null,
        cannotJoin: null
      }
    }
  ],
  transformIn: async (v, widgets) => {
    const { name, base, config, data } = v
    const _data = {}
    for (const key in data) {
      const value = await transformInTem([{ data: data[key].data }], widgets)
      _data[key] = value[0].cusTom
    }
    return {
      name,
      ...base,
      ...config,
      data: _data
    }
  },
  transformOut: (v) => {
    const value = cloneDeep(v)
    const _data = {}

    for (const key in value.data) {
      if (Object.prototype.hasOwnProperty.call(value.data, key)) {
        const { pages_template_id, template_title } = value.data[key] || {}
        _data[key] = { data: { pages_template_id, template_title } }
      }
    }
    value.data = _data
    return pickBy(value, {
      name: 'name',
      base: () => {
        return {}
      },
      config: (v) => {
        return pickBy(v, {
          joinStatus: 'joinStatus'
        })
      },
      data: 'data'
    })
  }
}
